import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endPoint from "../EndPoint/endpoint";

export const GetSellerData = createAsyncThunk(
  "getSeller/getSellerData",
  async (id, thunkAPI) => {
    try {
      const response = await axios.get(`${endPoint.GetSellerData}/${id}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const GetSellerDataSlice = createSlice({
  name: "GetSeller",
  initialState: {
    GetSeller: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetSellerData.fulfilled, (state, action) => {
        state.GetSeller = action.payload;
      })
      .addCase(GetSellerData.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default GetSellerDataSlice.reducer;
